import React from "react";
import { Video } from "../../Partials/Video/Video";
import { HeroProps } from "./HeroProps.csharp";
import { ResponsivePicture } from "../../ReactComponents/responsivePicture/responsivePicture";

export const Hero = (props: HeroProps) => {
    const hasImage = !!props.image;
    const hasMobileFallbackImage = !!props.imageMobileFallback;
    const hasVideo = !!props.videoUrl;
    const videoModifier = hasVideo ? "Hero--withVideo" : "";
    const overlayClass =
        props.overlay === "Dark" ? "Hero__overlay--dark" : props.overlay === "Light" ? "Hero__overlay--light" : "";

    const textColorClass = props.titleColor === "Black" ? "Hero__content--black" : "Hero__content--white";
    const buttonColorClass = props.titleColor === "Black" ? "button--black" : "button--white";
    return (
        <section className={`Hero`}>
            <div className={`Hero__content ${videoModifier} ${textColorClass} cover`}>
                {hasImage && (
                    <div className="image">
                        <ResponsivePicture
                            profile={props.defaultProfile}
                            model={props.image}
                            imgAttributes={{ "data-object-fit": "cover", "data-object-position": "center" }}
                        ></ResponsivePicture>
                        {hasMobileFallbackImage && (
                            <div className="image--mobileonly">
                                <ResponsivePicture
                                    profile={props.defaultProfile}
                                    model={props.imageMobileFallback}
                                    imgAttributes={{ "data-object-fit": "cover", "data-object-position": "center" }}
                                ></ResponsivePicture>
                            </div>
                        )}
                    </div>
                )}
                {hasVideo && (
                    <Video url={props.videoUrl!} mobileVideoUrl={props.videoUrl!} isMobile={props.showVideoOnMobile} />
                )}
                {props.mainButton?.target && !props.isFrontpageHero && (
                    <a href={props.mainButton.target}>
                        <div className={`Hero__overlay ${overlayClass}`}>
                            <div className="Hero__contentContainer">
                                <h1 className={`Hero__title ${textColorClass}`}>{props.title}</h1>
                                {props.ingress && (
                                    <div
                                        className="Hero__ingress"
                                        dangerouslySetInnerHTML={{ __html: props.ingress }}
                                    />
                                )}
                                {props.mainButton.text && (
                                    <div className="Hero__button">
                                        <div className={`button--secondary ${buttonColorClass}`}>
                                            <span>{props.mainButton.text}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </a>
                )}
                {!props.mainButton?.target && !props.isFrontpageHero && (
                    <div className={`Hero__overlay ${overlayClass}`}>
                        <div className="Hero__contentContainer">
                            <h1 className={`Hero__title ${textColorClass}`}>{props.title}</h1>
                            {props.ingress && (
                                <div className="Hero__ingress" dangerouslySetInnerHTML={{ __html: props.ingress }} />
                            )}
                        </div>
                    </div>
                )}
                {props.isFrontpageHero && (
                    <div className={`Hero__overlay ${overlayClass}`}>
                        <div className={`Hero__contentContainer--frontpage`}>
                            {props.heroVariant !== "TitleOnWhiteBackground" && (
                                <>
                                    <h1
                                        className={`Hero__title ${textColorClass} ${
                                            props.smallText && "Hero__title--small"
                                        }`}
                                    >
                                        {props.title}
                                    </h1>
                                    {props.ingress && (
                                        <div
                                            className={`Hero__ingress ${props.smallText && "Hero__ingress--small"}`}
                                            dangerouslySetInnerHTML={{ __html: props.ingress }}
                                        />
                                    )}
                                </>
                            )}
                            <div className={`Hero__whiteBox Hero__whiteBox--${props.heroVariant}`}>
                                {props.heroVariant === "TitleOnWhiteBackground" && (
                                    <>
                                        <h1
                                            className={`Hero__title Hero__title--black Hero__title--TitleOnWhiteBackground ${
                                                props.smallText && "Hero__title--small"
                                            }`}
                                        >
                                            {props.title}
                                        </h1>
                                        {props.ingress && (
                                            <div
                                                className={`Hero__ingress Hero__ingress--black Hero__ingress--TitleOnWhiteBackground  ${
                                                    props.smallText && "Hero__ingress--small"
                                                } `}
                                                dangerouslySetInnerHTML={{ __html: props.ingress }}
                                            />
                                        )}
                                    </>
                                )}
                                <div className={`Hero__statusBox Hero__statusBox--${props.heroVariant}`}>
                                    <div className="Hero__statusContainer">
                                        <span className="Hero__status">
                                            <strong>{props.currentStatus}</strong>
                                            <span>{props.currentTimeStatus}</span>
                                        </span>
                                        {props.reasonText && !props.reasonPageUrl && (
                                            <span className="Hero__reason">
                                                {props.reasonLabel && props.reasonLabel} {props.reasonText}
                                            </span>
                                        )}
                                        {props.reasonText && props.reasonPageUrl && (
                                            <span className="Hero__reason">
                                                {props.reasonLabel && props.reasonLabel}{" "}
                                                <a className="Hero__reason-link" href={props.reasonPageUrl}>
                                                    {props.reasonText}
                                                </a>
                                            </span>
                                        )}
                                        {props.openingHoursLabel && props.openingHoursUrl && (
                                            <span className="Hero__hoursLink">
                                                <a href={props.openingHoursUrl}>{props.openingHoursLabel}</a>
                                            </span>
                                        )}
                                    </div>
                                    <div
                                        className={`Hero__statusBox-buttons Hero__statusBox-buttons--${props.heroVariant}`}
                                    >
                                        {props.mainButton && props.mainButton.target && (
                                            <div className="Hero__statusBox-button ">
                                                <a
                                                    className={`button--primary Hero__first-button`}
                                                    href={props.mainButton.target}
                                                >
                                                    <span>{props.mainButton.text}</span>
                                                </a>
                                            </div>
                                        )}
                                        {props.secondButton && props.secondButton.target && (
                                            <div className="Hero__statusBox-button">
                                                <a
                                                    className={`button--secondary Hero__second-button`}
                                                    href={props.secondButton.target}
                                                >
                                                    <span>{props.secondButton.text}</span>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {props.isFrontpageHero &&
                (props.heroVariant === "Event" || props.heroVariant === "TitleOnWhiteBackground") && (
                    <div className="wrapper">
                        <div className="Hero__statusBox-buttons-container">
                            <div className="Hero__statusBox-buttons">
                                {props.mainButton?.target && (
                                    <div className="Hero__statusBox-button">
                                        <a
                                            className="button--primary Hero__first-button"
                                            href={props.mainButton.target}
                                        >
                                            <span>{props.mainButton.text}</span>
                                        </a>
                                    </div>
                                )}
                                {props.secondButton?.target && (
                                    <div className="Hero__statusBox-button">
                                        <a
                                            className="button--secondary Hero__second-button Hero__second-button--filled"
                                            href={props.secondButton.target}
                                        >
                                            <span>{props.secondButton.text}</span>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
        </section>
    );
};
